
import Items from '../views/Items.vue'
import Import from '../views/items/Import.vue'
import CreateLabel from '../views/CreateLabel.vue'
import ItemsCreate from '../views/items/Create.vue'
import Categories from '../views/items/Categories.vue'
import CategoriesCreate from '../views/items/CategoriesCreate.vue'
import Modifiers from '../views/items/Modifiers.vue'
import Discounts from '../views/items/Discounts.vue'
import MarkItems from '../views/items/MarkItems.vue'
import ItemsPricing from '../views/items/CreatePricing.vue'
import ItemsPriceChangeHistory from '../views/items/itemsPriceHistory.vue'
import ItemsAddGlobal from '../views/items/ItemCreateFromGlobal.vue'
import TechMap from '../views/items/TechMap.vue'
import TechMapDetail from '../views/items/TechMapDetail.vue'
import Mxik from '../views/items/Mxik.vue'
import Promotions from '../views/items/Promotions.vue'
import ItemsDiscountsCreate from '../views/items/ItemsCreateDiscount.vue'

const items = [
  {path: '/items/list', name: 'items', component: Items},
  {path: '/mxik/search', name: '', component: Mxik},
  {path: '/items/lists/:target', name: 'items_composite', component: Items},
  {path: '/items/lists/:target', name: 'items_store', component: Items},
  {path: '/items/import', name: 'import', component: Import},
  {path: '/items/create-label/:target', name: 'labels', component: CreateLabel},
  {path: '/items/list/:target', name: 'items_create', component: ItemsCreate},
  {path: '/items-list/:target_type/:target', name: 'items_composite_create', component: ItemsCreate},
  {path: '/items/categories', name: 'items_categories', component: Categories},
  {path: '/items/categories/:target', name: 'items_categories_create', component: CategoriesCreate},
  {path: '/items/modifiers', name: 'items_modifiers', component: Modifiers},
  {path: '/items/discounts', name: 'items_discounts', component: Discounts},
  {path: '/items/mark', name: 'items_mark', component: MarkItems},
  {path: '/items/create-pricing/:target', name: 'items_pricing', component: ItemsPricing},
  {path: '/items/history/price_change', name: 'price_change_history', component: ItemsPriceChangeHistory},
  {path: '/items/add-global', name: 'add_global', component: ItemsAddGlobal},
  {path: '/items/tech-map', name: 'tech_map', component: TechMap},
  {path: '/items/tech-map/detail/:target', name: 'tech_map_detail', component: TechMapDetail},
  {path: '/items/promotions', name: 'promotion', component: Promotions},
  {path: '/items/promotions/:target', name: 'promotion_create', component: ItemsDiscountsCreate}

]

export default {
  items
}


// function lazyLoad(view) {
//   return () => import(`@/views/items/${view}.vue`)
// }

// const items = [
//   {
//     path: '/items/list', name: 'items',
//     component: () => import(
//       '../views/Items.vue'
//     )
//   },
//   { path: '/mxik/search', name: '', component: lazyLoad('Mxik') },
//   {
//     path: '/items/lists/:target', name: 'items_composite', component: () => import(
//       '../views/Items.vue'
//     )
//   },
//   {
//     path: '/items/lists/:target', name: 'items_store', component: () => import(
//       '../views/Items.vue'
//     )
//   },
//   { path: '/items/import', name: 'import', component: lazyLoad('Import') },
//   { path: '/items/create-label/:target', name: 'labels', component: () => import(
//     '../views/CreateLabel.vue'
//   ) },
//   { path: '/items/list/:target', name: 'items_create', component: lazyLoad('Create') },
//   { path: '/items-list/:target_type/:target', name: 'items_composite_create', component: lazyLoad('Create') },
//   { path: '/items/categories', name: 'items_categories', component: lazyLoad('Categories') },
//   { path: '/items/categories/:target', name: 'items_categories_create', component: lazyLoad('CategoriesCreate') },
//   { path: '/items/modifiers', name: 'items_modifiers', component: lazyLoad('Modifiers') },
//   { path: '/items/discounts', name: 'items_discounts', component: lazyLoad('Discounts') },
//   { path: '/items/mark', name: 'items_mark', component: lazyLoad('MarkItems') },
//   { path: '/items/create-pricing/:target', name: 'items_pricing', component: lazyLoad('CreatePricing') },
//   { path: '/items/history/price_change', name: 'price_change_history', component: lazyLoad('itemsPriceHistory') },
//   { path: '/items/add-global', name: 'add_global', component: lazyLoad('ItemCreateFromGlobal') },
//   { path: '/items/tech-map', name: 'tech_map', component: lazyLoad('TechMap') },
//   { path: '/items/tech-map/detail/:target', name: 'tech_map_detail', component: lazyLoad('TechMapDetail') },
//   { path: '/items/promotions', name: 'promotion', component: lazyLoad('Promotions') },
//   { path: '/items/promotions/:target', name: 'promotion_create', component: lazyLoad('ItemsCreateDiscount') }

// ]

